<template>
  <div class="layout">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'layout',
};
</script>

<style lang="scss" scoped>

.layout {
  position: relative;
  height: 100%;
  width: 100%;
  background-color: var(--nxt-color-white);
}
</style>
